"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/MYFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_164)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_164`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V1.71228H-6V0ZM-6 3.43158H30V5.14386H-6V3.43158ZM-6 6.85614H30V8.56842H-6V6.85614ZM-6 10.2877H30V12H-6V10.2877ZM-6 13.7123H30V15.4246H-6V13.7123ZM-6 17.1439H30V18.8561H-6V17.1439ZM-6 20.5684H30V22.2807H-6V20.5684Z",
					fill: "#CC0000"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H12V13.7123H-6V0Z",
					fill: "#000066"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.75793 2.95434C2.60354 2.15434 0.210559 3.24908 -0.589441 5.40346C-1.38944 7.55785 -0.294704 9.95083 1.85968 10.7508C2.79302 11.1017 3.82459 11.1017 4.76495 10.7508C2.61056 12.4701 -0.526283 12.1263 -2.2526 9.97189C-3.97891 7.8175 -3.62804 4.68066 -1.47365 2.95434C0.35091 1.50171 2.94038 1.50171 4.75793 2.95434ZM6.63161 8.2175L5.186 9.85259L5.56495 7.70522L3.38951 7.59294L5.3053 6.54732L4.03512 4.77189L6.04214 5.61399L6.63161 3.51575L7.22109 5.61399L9.2281 4.77189L7.96495 6.55434L9.88074 7.59996L7.7053 7.71224L8.08424 9.85961L6.63161 8.2175Z",
					fill: "#FFCC00"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_164`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as MYFlag };
